// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"c13583a5","801":"7c37d04b"}[chunkId] + ".chunk.js";
};